import styled from 'styled-components'

export const Content = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: flex-start;
	/*max-width: 600px;
	margin: auto; */
`